/**
 * Created by chenzheyu on 2017/7/6.
 */
import XkUpImgDom from './src/upImg.vue'

XkUpImgDom.install = function (Vue) {
  Vue.component(XkUpImgDom.name, XkUpImgDom)
}

export default XkUpImgDom



// WEBPACK FOOTER //
// ./src/components/module/upImg/index.js